import { render, staticRenderFns } from "./LeaveReviewForm.vue?vue&type=template&id=4acfc455"
import script from "./LeaveReviewForm.vue?vue&type=script&lang=js"
export * from "./LeaveReviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports